import styled, { css } from 'styled-components';
import { rem } from 'polished';
import {
  colors,
  isDefaultThemeMode,
  accessibilityBorder,
  accessibilityHoverInvert,
  ease, duration,
} from 'core/theme';

const color = ({accent}) => {
  let color;
  switch (accent) {
    case 'primary':
      color = colors.primary;
      break;
    case 'secondary':
      color = colors.secondary;
      break;
    default:
  }

  return color && css`
    color: ${color};
  `;
};

const accessibilityBorderExtend = (props) => !isDefaultThemeMode(props) && css`
  ${accessibilityBorder};
  border-width: 2px;

  &:hover {
    border-color: ${colors.background};
  }
`;

const ButtonFAB = styled.button`
  background-color: ${colors.background};
  border: 0;
  border-radius: 50%;
  box-shadow: 0 0 6px 0 rgba(0,0,0,0.12), 0 6px 6px 0 rgba(0,0,0,0.24);
  ${color};
  font-size: 1em;
  width: ${({compact}) => compact ? rem(40) : rem(56)};
  height: ${({compact}) => compact ? rem(40) : rem(56)};
  cursor: pointer;

  & > span {
    padding: 0;
  }

  border: 1px solid transparent;
  transition-property: background-color, border, color, transform;
  transition-duration: ${duration.fast};
  transition-timing-function: ${ease.standard};

  &:hover {
    background-color: ${colors.secondary};
    border: 2px solid ${colors.background};
    color: ${colors.background};
    transform: scale(1.2) translateY(45%);
  }

  ${accessibilityBorderExtend};
  ${accessibilityHoverInvert};
`;

export default ButtonFAB;



// WEBPACK FOOTER //
// ./src/elements/Button/styled/ButtonFAB.js